import { AbstractControl, ValidationErrors } from '@angular/forms';
import { checkObjectMask, GetGoodsClassifierData, checkMissingValuesValidator } from '@shared';

export function getGoodsClassifierDescription(item: GetGoodsClassifierData | string): string {
  if (!item) {
    return '';
  }

  if (typeof item === 'string') {
    return item;
  }

  if (!item.SubCategoryDescription) {
    return String(item.ProductDescription);
  }

  if (!item.ProductDescription) {
    return String(item.SubCategoryDescription);
  }

  return `${item.SubCategoryDescription}: ${item.ProductDescription}`;
}

export const goodsClassifierResultKeys = Object.keys({} as GetGoodsClassifierData).map((key) => key as keyof GetGoodsClassifierData);

export const goodsClassifierMaskValidator = checkObjectMask(goodsClassifierResultKeys);

export const goodsClassifierObjectValuesValidator = checkMissingValuesValidator(['HsCodeDept']);

export const descriptionMinLengthRozniza = 3;

export const descriptionMinLengthBusiness = 2;

export function noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
  if (typeof control.value !== 'string') {
    return null;
  }
  const isWhitespace = (control.value || '').trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : { required: true };
}
